export default __webpack_public_path__ + "static/media/poster3.90c78227.jpg";